import { Pagination as r } from "@ark-ui/react/pagination";
import e, { forwardRef as h } from "react";
import { cx as n, css as i } from "@huspy/styled-system/css";
import { splitCssProps as C } from "@huspy/styled-system/jsx";
import { pagination as p } from "@huspy/styled-system/recipes";
import { ChevronLeft as d, ChevronRight as x } from "lucide-react";
import { token as g } from "@huspy/styled-system/tokens";
import { Flex as l } from "../box/index.mjs";
import { Button as I } from "../button/button.mjs";
const R = h((c, f) => {
  const [u, E] = p.splitVariantProps(c), [a, P] = C(E), { className: o, ...v } = P, t = p(u);
  return /* @__PURE__ */ e.createElement(l, { alignItems: "center", justify: "center" }, /* @__PURE__ */ e.createElement(
    r.Root,
    {
      className: n(t.root, i(a), o),
      ref: f,
      ...v
    },
    /* @__PURE__ */ e.createElement(r.PrevTrigger, { className: t.prevTrigger, asChild: !0 }, /* @__PURE__ */ e.createElement(
      l,
      {
        alignItems: "center",
        justify: "center",
        className: n(t.chevron, i(a), o)
      },
      /* @__PURE__ */ e.createElement(d, { color: g.var("colors.fg-tertiary") })
    )),
    /* @__PURE__ */ e.createElement(r.Context, null, (y) => y.pages.map((s, m) => {
      if (s.type === "page") {
        const N = s.value === c.page;
        return /* @__PURE__ */ e.createElement(
          r.Item,
          {
            className: n(t.item, i(a), o),
            key: m,
            ...s,
            asChild: !0
          },
          /* @__PURE__ */ e.createElement(I, { variant: N ? "secondary" : "quaternary", size: "sm" }, s.value)
        );
      }
      return /* @__PURE__ */ e.createElement(r.Ellipsis, { key: m, index: m, className: t.ellipsis }, "…");
    })),
    /* @__PURE__ */ e.createElement(r.NextTrigger, { className: t.nextTrigger, asChild: !0 }, /* @__PURE__ */ e.createElement(
      l,
      {
        alignItems: "center",
        justify: "center",
        className: n(t.chevron, i(a), o)
      },
      /* @__PURE__ */ e.createElement(x, { color: g.var("colors.fg-tertiary") })
    ))
  ));
});
R.displayName = "Pagination";
export {
  R as Pagination
};
